import { SponsorCodeContext } from '@rhg/providers/magic-link';
import { useContext } from 'react';

export function useSponsorCode() {
    return useContext(SponsorCodeContext);
}
